import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CampaignTrackingParameterService = /*#__PURE__*/function () {
  function CampaignTrackingParameterService(tracked) {
    _classCallCheck(this, CampaignTrackingParameterService);

    this.params = {};
    this.tracked = tracked;
  }

  _createClass(CampaignTrackingParameterService, [{
    key: "add",
    value: function add(params) {
      var keys = Object.keys(params);

      for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
        var key = _keys[_i];

        if (this.tracked.includes(key)) {
          this.params[key] = params[key];
        }
      }
    }
  }, {
    key: "get",
    value: function get(paramName) {
      return this.params[paramName] || null;
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return _objectSpread({}, this.params);
    }
  }]);

  return CampaignTrackingParameterService;
}();

export { CampaignTrackingParameterService as default };